import DebugUANC from '../../../core/version/debug';
import { saveToLocalStorage } from '../../localStore';
import { PLUGIN_NAME } from '../config';

const sidebarSelectors = ['aside.main-sidebar', 'div.f3-sidebar-container'];
const setCustomKeywordsValue = (): string[] => {
    const { Ad } = window.Inpl;

    const sidebar: Element | null =
            sidebarSelectors
                .map((selector: string) => document.querySelector(selector) as Element)
                .find((element: Element | null) => element !== null) || null,
        keywords: string[] = [];

    if (Ad.detection?.device) keywords.push(`ck_device_${Ad.detection.device}`);
    if (Ad.detection?.browser) keywords.push(`ck_browser_${Ad.detection.browser}`);

    if (sidebar) {
        const sbrDisplay = window.getComputedStyle(sidebar).getPropertyValue('display') || 'none';
        keywords.push(sbrDisplay === 'block' ? 'rsb1' : 'rsb0');
    }

    return keywords;
};

/**
 * Inicjuje plugin CustomKeywords.
 *
 * @returns {Promise<PLUGIN_NAME | Error>} Nazwa załadowanego pluginu lub w przypadku problemów przekazanie informacja o błędzie.
 */
export const processCustomKeywords = (): PLUGIN_NAME | Error => {
    const { Ad } = window.Inpl;

    try {
        const keywords: string[] = setCustomKeywordsValue();
        saveToLocalStorage('ad_custom_keywords', keywords);
        Ad.plugins = {
            ...Ad.plugins,
            [PLUGIN_NAME.CUSTOM_KEYWORDS]: {
                isEnabled: true,
                keywords,
            },
        };
        if (Ad.UANC instanceof DebugUANC) {
            Ad.UANC.info('Plugin Custom Keywords', `has been successfully embedded. Keywords: ${keywords.length ? keywords : ['---']}`);
        }
        return PLUGIN_NAME.CUSTOM_KEYWORDS;
    } catch (e) {
        throw new Error(`[CustomKeywords] - problem loading the plugin. ${e}`);
    }
};
